import React from "react";
import { MarketingLayout } from "@/components/MarketingLayout";
import { Card } from "@/components/ui/card";

const POSTS = [
  { title: "What is a 'good' NPS in 2026?", excerpt: "Industry benchmarks for SaaS, retail, hospitality and banking — and what really moves the needle.", tag: "Benchmarks" },
  { title: "Designing surveys people actually finish", excerpt: "10 design principles backed by 40M+ responses. Reduce drop-off from 60% to 10%.", tag: "Best practices" },
  { title: "Closing the loop without burning out CSMs", excerpt: "How to automate detractor follow-ups while keeping the human touch.", tag: "Operations" },
  { title: "Multilingual CX: the silent revenue lever", excerpt: "Why running English-only surveys in global markets misreads loyalty by 18 points.", tag: "Global CX" },
];

export default function BlogPage() {
  return (
    <MarketingLayout>
      <section className="max-w-6xl mx-auto px-6 py-16">
        <p className="text-xs uppercase tracking-wider font-semibold text-[#F58220]">Blog</p>
        <h1 className="mt-2 text-4xl md:text-5xl font-extrabold tracking-tight text-[#1F3A6B]">CX, loyalty, and AI insights</h1>
        <p className="mt-3 text-slate-600 text-lg max-w-2xl">Field-tested perspectives from CX leaders building world-class customer programs.</p>

        <div className="mt-10 grid md:grid-cols-2 gap-5">
          {POSTS.map((p) => (
            <Card key={p.title} data-testid={`blog-post-${p.title.toLowerCase().replace(/\s+/g, "-")}`} className="p-6 border-slate-100 hover:shadow-elev-2 transition-shadow cursor-pointer">
              <span className="text-[10px] font-bold uppercase tracking-wider text-[#F58220] bg-[#FFF0DF] px-2 py-0.5 rounded-full">{p.tag}</span>
              <h3 className="mt-3 text-xl font-extrabold text-[#1F3A6B]">{p.title}</h3>
              <p className="mt-2 text-sm text-slate-600">{p.excerpt}</p>
              <p className="mt-4 text-xs text-slate-500">5 min read · Coming soon</p>
            </Card>
          ))}
        </div>
      </section>
    </MarketingLayout>
  );
}
